module.exports = __webpack_public_path__ + "img/profile-logo.0b96ab41.png";